import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DeletedObjectToggleComponent } from './deleted-object-toggle.component';

@NgModule({
	imports: [
		CommonModule,
		ToggleSwitchComponent
	],
	declarations: [
		DeletedObjectToggleComponent
	],
	exports: [
		DeletedObjectToggleComponent
	]
})
export class DeletedObjectToggleComponentModule {

}
